import { mdiChevronRight, mdiFileDocumentPlusOutline } from '@mdi/js';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import Icon from '@mdi/react';
import React from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import './TicketsWidget.scss';
import { getTicketsCount } from '../../../store/apis/ticketService';

function TicketsWidget({ admin }) {
  const navigate = useNavigate();
  const { data: myTicketsCount } = useQuery({
    queryKey: ['myTicketsCount'],
    queryFn: () => getTicketsCount(),
    enabled: true,
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: 'always',
  });

  return (
    <Card
      className="ticket-widget"
      style={{ border: '1px solid #98A2B3', borderRadius: '16px' }}
    >
      <CardHeader
        className="d-flex flex-row align-items-center gap-2 pb-0"
        style={{
          borderRadius: '8px 8px 0px 0px',
          borderBottom: 'none',
        }}
      >
        <div>
          <Icon path={mdiFileDocumentPlusOutline} size="20px" color="#363F72" />
        </div>
        <div className="fs-5" style={{ fontWeight: '600', color: '#363F72' }}>
          <span className="fw-semibold fs-5 tickets-label">Tickets</span>
        </div>
      </CardHeader>
      <CardBody className="d-flex flex-row justify-content-between align-items-center gap-3 px-3 pb-1 pt-0 w-100 overflow-hidden">
        {admin && (
          <>
            <button
              type="button"
              className="admin-ticket-wrapper w-50 py-3 px-3"
              onClick={() => navigate('/hr/tickets?t=2')}
              title="View all tickets in the system, including resolved and assigned ones."
            >
              <span className="fw-semibold fs-4">
                {myTicketsCount?.allTicketsCount || 0}
              </span>
              <div className="d-flex flex-row align-items-center justify-content-between w-100">
                <span className="fs-6">All Tickets</span>
                <Icon path={mdiChevronRight} size={0.9} color="#0DA6EA" />
              </div>
            </button>
            <button
              type="button"
              className="admin-ticket-wrapper w-50 py-3 px-3"
              onClick={() => navigate('/hr/tickets?t=1')}
              title="Tickets that are currently assigned to you for action."
            >
              <span className="fw-semibold fs-4">
                {myTicketsCount?.assignedTicketsCount || 0}
              </span>
              <div className="d-flex flex-row align-items-center justify-content-between w-100">
                <span className="fs-6">Assigned</span>
                <Icon path={mdiChevronRight} size={0.9} color="#0DA6EA" />
              </div>
            </button>
          </>
        )}
        {!admin && (
          <>
            {' '}
            <button
              type="button"
              className="ticket-wrapper"
              onClick={() => navigate('/hr/tickets?t=1')}
              title="Tickets that are currently assigned to you for action."
            >
              <span className="fw-semibold fs-4">
                {myTicketsCount?.assignedTicketsCount || 0}
              </span>
              <div className="d-flex flex-row align-items-center justify-content-between w-100">
                <span className="fs-6">Assigned</span>
                <Icon path={mdiChevronRight} size={0.7} color="#0DA6EA" />
              </div>
            </button>
            <button
              type="button"
              className="ticket-wrapper"
              onClick={() => navigate('/hr/tickets?t=3')}
              title="Tickets that are currently assigned to you for action."
            >
              <span className="fw-semibold fs-4">
                {myTicketsCount?.myTicketsCount || 0}
              </span>
              <div className="d-flex flex-row align-items-center justify-content-between w-100">
                <span className="fs-6">My Tickets</span>
                <Icon path={mdiChevronRight} size={0.7} color="#0DA6EA" />
              </div>
            </button>
          </>
        )}
      </CardBody>
    </Card>
  );
}

export default TicketsWidget;
